import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Flame, CheckCircle2 } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 30,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        seconds -= 1;
        if (seconds < 0) {
          seconds = 59;
          minutes -= 1;
        }
        if (minutes < 0) {
          minutes = 0;
          seconds = 0;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="comprar" className="py-14 sm:py-18 px-4 sm:px-6 lg:px-8 bg-deco-bg relative overflow-hidden scroll-mt-10" data-id="element-178">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-deco-terra/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-179"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-deco-sage/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-180"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-181">
        <div className="text-center mb-10" data-id="element-182">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-183">
            <span className="text-deco-text/80 font-semibold text-sm sm:text-base uppercase tracking-wider" data-id="element-184">
              Esta oferta termina en
            </span>
            <div className="flex items-center gap-1.5 font-mono text-lg sm:text-xl font-bold" data-id="element-185">
              <span className="bg-deco-terra text-white rounded-lg px-3 py-2 min-w-[48px] text-center shadow-lg" data-id="element-186">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-deco-terra text-2xl font-bold" data-id="element-187">:</span>
              <motion.span key={`ps-${timeLeft.seconds}`} initial={{
              scale: 1.1
            }} animate={{
              scale: 1
            }} transition={{
              duration: 0.15
            }} className="bg-deco-terra text-white rounded-lg px-3 py-2 min-w-[48px] text-center shadow-lg" data-id="element-188">
                {pad(timeLeft.seconds)}
              </motion.span>
            </div>
          </div>
        </div>

        <div className="max-w-md mx-auto" data-id="element-189">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-deco-terra text-white rounded-[2rem] p-8 sm:p-10 shadow-2xl border border-deco-terra relative flex flex-col text-center" data-id="element-190">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-deco-terra px-6 py-2 rounded-full text-sm font-bold uppercase tracking-wider shadow-md whitespace-nowrap" data-id="element-191">
              COMENZÁ A CREAR HOY
            </div>

            <div className="mt-4" data-id="element-192">
              <h3 className="text-2xl sm:text-3xl font-serif font-bold mb-6" data-id="element-193">
                Kit Flores Eternas Deco
              </h3>
              <p className="text-lg sm:text-xl text-white/60 line-through mb-1" data-id="element-194">
                $39.990 ARS
              </p>
              <p className="text-5xl sm:text-6xl font-bold mb-8" data-id="element-195">
                $19.990{' '}
                <span className="text-xl text-white/80 font-normal" data-id="element-196">ARS</span>
              </p>
            </div>

            <div className="space-y-3 mb-8 text-left" data-id="element-197">
              {['Recibís todo el material al instante', 'Podés verlo desde celular, tablet o computadora', 'Acceso de por vida al contenido', 'Incluye actualizaciones si el kit se actualiza', 'Ideal para aprender, regalar o vender'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-198">
                  <span className="text-base shrink-0 mt-0.5" data-id="element-199">✅</span>
                  <span className="text-white/90 text-sm font-medium" data-id="element-200">
                    {item}
                  </span>
                </div>)}
            </div>

            <motion.a href="https://pago.atlasdigitalhub.com/cart/42966895067234:1" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0px 0px 0px 0px rgba(255,255,255,0.4)', '0px 0px 0px 15px rgba(255,255,255,0)', '0px 0px 0px 0px rgba(255,255,255,0)']
          }} transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: 'loop'
          }} className="block w-full py-5 px-6 rounded-full bg-white text-deco-terra font-bold text-center hover:bg-white/90 transition-colors shadow-xl uppercase tracking-wider text-base sm:text-lg" data-id="element-201">
              QUIERO EMPEZAR HOY
            </motion.a>
          </motion.div>
        </div>

        <div className="flex items-center justify-center gap-2 mt-10 text-xs sm:text-sm text-deco-taupe font-medium text-center" data-id="element-202">
          <ShieldCheck size={16} className="shrink-0" data-id="element-203" />
          <span data-id="element-204">
            Pago seguro · Acceso digital inmediato · Material de por vida
          </span>
        </div>
      </div>
    </section>;
}